export const MODAL_TYPE_CAPTCHA_CONFIRMATION = 'captcha-confirmation-modal';
